import instance from '@apis/instance';
import {
    CouponRow,
    DownloadableCouponRow,
    UserCouponResponse,
    GetCouponsParams,
    GetDownloadableCouponsParams, PaperCouponResponse,
} from '@models/coupon';
import { SliceResponse } from '@models/page';

class CouponApi {
    static registerPaperCoupon(code: string): Promise<never> {
        return instance.post('/v0/coupons/paper-coupon', { code });
    }

    static getMyCoupons(params: GetCouponsParams): Promise<SliceResponse<CouponRow>> {
        return instance.get('/v0/user-coupons', { params });
    }

    static getMyCoupon(id: string): Promise<UserCouponResponse> {
        return instance.get(`/v0/user-coupon/${id}`);
    }

    static getCouponHistories(params: GetCouponsParams): Promise<SliceResponse<CouponRow>> {
        return instance.get('/v0/user-coupons/history', { params });
    }

    static getDownloadableCoupons(params: GetDownloadableCouponsParams): Promise<SliceResponse<DownloadableCouponRow>> {
        return instance.get('/v0/coupons/download-event', { params });
    }

    static getPaperCoupon(code: string): Promise<PaperCouponResponse> {
        return instance.get(`/v0/coupons/paper-coupon/${code}`);
    }

    static downloadCoupon(eventId: string) : Promise<never> {
        return instance.post(`/v0/coupons/download-event/${eventId}`);
    }
}

export default CouponApi;
